export default {
  customer: [
    {
      path: "/dashboard",
      iconStyle: imagepaths.Dashboard,
      iconActive: imagepaths.DashboardActive,
      label: "Home",
    },
    {
      path: "/mycontent",
      iconStyle: imagepaths.ContentIcon,
      iconActive: imagepaths.ContentIconActive,
      label: "My Content",
    },
    {
      path: "/allcontent",
      iconStyle: imagepaths.ContentIcon,
      iconActive: imagepaths.ContentIconActive,
      label: "Buy Content",
    },
    {
      path: "/myprofile",
      iconStyle: imagepaths.UserIcon,
      iconActive: imagepaths.UserIconActive,
      label: "Profile",
    },
  ],
};